<template>
  <div>
    <v-card :class="{ 'pt-3': logoAsImage }" v-if="news.id" :to="{ name: 'news', params: { id: news.id } }">

      <v-img :src="primaryImage.full_hd" :aspect-ratio="16 / 10" :contain="logoAsImage">
        <v-card-title
          style="background-color: rgba(0, 0, 0, 0.5);color: #FFF !important;position: absolute;border: 0;bottom: 0;width: 100%; font-size: 1.5rem">
          {{ news.title }}
        </v-card-title>
      </v-img>
      <br>
      <v-card-text>
        <div v-html="preview"></div>
        <v-row class="mt-1">
          <v-col>
            <!-- <span class="group-indicator">
              {{ news.group_name }}
            </span> -->
            <v-chip small> {{ getDateTime(news.release_date) }} </v-chip>
          </v-col>
          <v-col>
            <div class="float-right">
              <v-chip small> {{ news.group_name }} </v-chip>
              <!-- <span class="group-indicator">
                {{ getDateTime(news.release_date) }}
              </span> -->
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { getDateTime } from "@/@core/utils/datetime_helpers";
import useMarkdown from "@/@core/utils/useMarkdown";
import { computed } from "@vue/composition-api";
import useAuth from "@/useAuth";
import useNewsImage from "@/@core/utils/useNewsImage";


export default {
  props: ["news"],
  setup(props) {
    const { markdownToHtml } = useMarkdown();
    const { getPrimaryImage } = useNewsImage();
    const { tenant } = useAuth();
    const preview = computed(() => {
      const news = props.news;
      if (!news || !news.text) return "";

      var html = markdownToHtml(news.text);
      var element = document.createElement("div");
      element.innerHTML = html;

      var first = element.firstChild;
      if (first.textContent.length > 300)
        return first.textContent.substring(0, 300) + "...";

      return first.textContent;
    });


    const primaryImage = computed(() => {
      return getPrimaryImage(props.news);
      // if (Object.keys(props.news).length) {
      //   if (Object.keys(props.news.image).length) {
      //     return props.news.image;
      //   }
      // }
      // if (tenant.value.news_image != null) {
      //   return tenant.value.news_image;
      // }
      // return tenant.value.logo;
    });

    const logoAsImage = computed(() => {
      return primaryImage.value.thumbnail == tenant.value.logo.thumbnail;

    });

    return {
      getDateTime,
      preview,
      tenant,
      logoAsImage,
      primaryImage
    };
  },
};
</script>

<style></style>
